import React, { useEffect, useRef } from "react";
import { Animated, StyleSheet, Text, View } from "react-native";
import Svg, { Circle } from "react-native-svg";
import { Colors } from "../../../../../styles";

const CircularProgress = ({ duration = 60, loop = false, timeLeft }) => {
  const animatedValue = useRef(new Animated.Value(0)).current;

  const AnimatedCircle = Animated.createAnimatedComponent(Circle);

  const startAnimation = () => {
    Animated.timing(animatedValue, {
      toValue: 1,
      duration: duration * 1000,
      useNativeDriver: false,
    }).start(() => {
      if (loop) {
        animatedValue.setValue(0); // Reinicia o valor da animação
        // setTimeLeft(duration); // Reinicia o tempo
        startAnimation(); // Reinicia a animação
      }
    });
  };

  // Lógica do countdown
  useEffect(() => {
    startAnimation();

  //   const interval = setInterval(() => {
      // setTimeLeft((prev) => {
      //   if (prev > 1) return prev - 1;
      //   if (loop) return duration; 
      //   clearInterval(interval); 
      //   return 0;
      // });
  //   }, 1000);

  //   return () => clearInterval(interval);
  }, []);

  const strokeDashoffset = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 2 * Math.PI * 45], // Circunferência do círculo
  });

  return (
    <View style={styles.container}>
      <Svg width="64" height="64" viewBox="0 0 100 100">
        <Circle
          cx="50"
          cy="50"
          r="45"
          stroke={"#e6e6e6"}
          strokeWidth="10"
          fill="none"
        />
        {/* Animated Progress Circle */}
        <AnimatedCircle
          cx="50"
          cy="50"
          r="45"
          stroke={Colors.SECONDARY}
          strokeWidth="10"
          fill="none"
          strokeDasharray={`${2 * Math.PI * 45}, ${2 * Math.PI * 45}`}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
        />
      </Svg>
      <Text style={styles.timer}>{timeLeft}s</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
  },
  timer: {
    position: "absolute",
    fontSize: 16,
    fontWeight: "bold",
    color: Colors.SECONDARY,
  },
});

export default CircularProgress;
